/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2021-08-18 17:48:56
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2025-08-26 16:10:23
 */
// 发票管理
const map = {
  invoiceManagement: () => import('@/views/invoice/InvoiceManagement'), // 销项发票管理
  incomeInvoiceManagement: () =>
    import('@/views/invoice/IncomeInvoiceManagement'), // 进项发票管理
  businessControl: () => import('@/views/finance/BusinessControl'), // 业务渠道管控设置
  purchaseInvoiceList: () => import('@/views/invoice/PurchaseInvoiceList'), // 采购发票列表
  redManInvoiceList: () => import('@/views/invoice/RedManInvoiceList'), // 红人发票列表
  createPurchaseInvoice: () =>
    import('@/views/invoice/components/PurchaseInvoiceDetail'), // 新建采购发票
  editPurchaseInvoice: () =>
    import('@/views/invoice/components/PurchaseInvoiceDetail'), // 查看采购发票
  createRedManInvoice: () =>
    import('@/views/invoice/components/PurchaseInvoiceDetail'), // 新建红人结算发票
  editRedManInvoice: () =>
    import('@/views/invoice/components/PurchaseInvoiceDetail'), // 查看红人结算发票
  adInvoicePackageModuleDetail: () =>
    import('@/views/invoice/components/AdInvoicePackageModuleDetail'), // 发票夹详情
  PBShopInvoiceApply: () => import('@/views/invoice/PBShopInvoiceApply'), // PB开票申请
  PBShopInvoiceApplyDetail: () => import('@/views/invoice/PBShopInvoiceApplyDetail'), // PB开票详情
  inputInvoiceApprove: () => import('@/views/invoice/InputInvoiceApprove'), // 进项发票交接列表
  inputInvoiceApproveDetail: () => import('@/views/invoice/InputInvoiceApprove/Detail.vue'), // 进项发票交接详情
  InputInvoiceTrack: () => import('@/views/invoice/InputInvoiceTrack'), // 进项发票交接列表
  PBkpApplyDetail: () => import('@/views/invoice/PBkpApplyDetail'), // PB进项发票交接详情
  PlatformSubsidiesAutoInvoiceList: () => import('@/views/invoice/PlatformSubsidiesAutoInvoiceList/index'), // 平台补贴自动开票列表
  OnlineInvoiceApply: () => import('@/views/invoice/OnlineInvoiceApply'), // 线上开票申请
  OnlineInvoiceApplyDetail: () => import('@/views/invoice/OnlineInvoiceApply/Detail.vue'), // 线上开票详情
  createOfflineInvoiceRegistration: () => import('@/views/invoice/OfflineInvoiceRegistration/Detail.vue'), // 达人佣金线下发票登记
  offlineInvoiceRegistrationDetail: () => import('@/views/invoice/OfflineInvoiceRegistration/Detail.vue'), // 达人佣金线下发票登记详情
  platformInvoiceNameTypeMap: () =>
    import('@/views/invoice/finance/PlatformInvoiceNameTypeMap.vue'), // 平台发票名称类型映射
  PlatformInvoiceNameTypeMap: () =>
    import('@/views/invoice/finance/PlatformInvoiceNameTypeMap.vue'), // 与菜单路由名 PascalCase 兼容
  NoSourceOrderInvoiceTypeConfig: () =>
    import('@/views/invoice/NoSourceOrderInvoiceTypeConfig/index.vue') // 无源单开票业务类型配置
}

export default map
